import React, { Component } from "react";
import logo from '../assets/main-logo.png';
import "./Navbaranim.scss";
import { Link } from "react-router-dom";
import { Dimensions } from '../Helper/sitedimension';


class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      active: false,
      open: false
    };
  }

  dimensionHandler = () => {
    const { width } = Dimensions.useWindowDimensions();
    return width;
  }

  toggleClassHandler = () => {
    this.setState({ active: !this.state.active });
    this.setState({ open: !this.state.open });
  };


  render() {
    return (
      <div className="navbar2" style={{ overflowX: "hidden", overflowY: "hidden" }}>
        <div>
          <Link className="nav-logo" to="/">
            {this.dimensionHandler > 500 ?
              < img src={logo} alt="logo" style={{ width: "220px", height: "50px", marginBottom: "0px" }} /> :
              < img src={logo} alt="logo" style={{ width: "200px", height: "50px", marginBottom: "50px", marginTop: "25px", marginLeft: "-15px" }} />}
          </Link>
        </div>
        {this.dimensionHandler > 500 ?
          <div
            className={
              this.state.active ? "button_container active" : "button_container"
            }
            onClick={this.toggleClassHandler}
            style={{ paddingTop: "20px" }}
          >
            <span className="top"></span>
            <span className="middle"></span>
            <span className="bottom"></span>
          </div> :
          <div
            className={
              this.state.active ? "button_container active" : "button_container"
            }
            onClick={this.toggleClassHandler}
            style={{ paddingTop: "35x", position: "absolute", right: "25px" }}
          >
            <span className="top"></span>
            <span className="middle"></span>
            <span className="bottom"></span>
          </div>
        }

        <div
          className={this.state.open ? "overlay2 open" : "overlay2"}
          onClick={this.toggleClassHandler}
        >
          <nav className="overlay-menu">
            <ul>
              <li>
                <Link className="navs" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="navs" to="/services">
                  Services
                </Link>
              </li>
              <li>
                <Link className="navs" to="/about">
                  About Us
                </Link>
              </li>
              <li>
                <Link className="navs" to="/product">
                  Product
                </Link>
              </li>
              <li>
                <Link className="navs" to="/contactus">
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}
export default Navbar;
